export function addChainId(chainId, object) {
    Object.defineProperty(object, 'chainId', {
        value: chainId,
        enumerable: true,
    });
    return object;
}
